var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoAtencao01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_436",
    d: "M16.1,13.5h3.8v9.4h-3.8V13.5z M16.1,24.7h3.8v3.8h-3.8V24.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_437",
    d: "M21.3,3.2c-1-1.8-3.2-2.5-5.1-1.6C15.6,2,15,2.6,14.7,3.2l-13.8,26c-1,1.8-0.3,4.1,1.6,5.1 c0.5,0.3,1.1,0.4,1.8,0.4h27.6c2.1,0,3.8-1.7,3.8-3.8c0-0.6-0.1-1.2-0.4-1.8L21.3,3.2z M4.2,31L18,5l13.8,26H4.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAtencao01);
export default __webpack_public_path__ + "static/media/ico-atencao-01.419486955496a3a278441ab342d9a4a7.svg";
export { ForwardRef as ReactComponent };